import { ICustomerSalesProductPayment } from "@/interfaces/customer-sales-product-payment.interfaces";
import { FilterType, IFilter } from "@/types/filter.types";

export const determineInitialFilterValues2 = (
  salesProductId: number
): IFilter<ICustomerSalesProductPayment>[] => {
  const initialFilterValues: IFilter<ICustomerSalesProductPayment>[] = [
    {
      property: "salesProductPriceId",
      value: salesProductId,
      filterType: FilterType.Equals,
    },
  ];

  return initialFilterValues;
};
